module.exports = __webpack_public_path__ + "assets/img/edit_value.fc4d9c3f.png";